import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // } ,
    {
      path: '/',
      name: 'home',
      meta: {
        title: '仓库管理'
      },
      component: () => import('@/views/index.vue')
    },
    

    {
      path: '/Pro_inout',
      name: 'Pro_In_Out',
      meta: {
        title: '产品出入库'
      },
      component: () => import('@/views/pro_in_out.vue')
    },

    {
      path: '/Pro_inout/:startdate/:enddate',
      name: 'Pro_In_Out',
      meta: {
        title: '产品出入库'
      },
      component: () => import('@/views/pro_in_out.vue')
    },

    {
      path: '/Pro_details/:pid/:storeid/:LevelText/:plevel',
      name: 'Pro_details',
      meta: {
        title: '产品出入库详情'
      },
      component: () => import('@/views/pro_details.vue')
    },

    {
      path: '/Pro_online/:storeid',
      name: 'Pro_online',
      meta: {
        title: '出库产品'
      },
      component: () => import('@/views/pro_online.vue')
    },


    {
      path: '/Pro_online/',
      name: 'Pro_online',
      meta: {
        title: '出库产品_全部'
      },
      component: () => import('@/views/pro_online.vue')
    },

    {
      path: '/Pro_move/:date',
      name: 'Pro_move',
      meta: {
        title: '移库'
      },
      component: () => import('@/views/pro_move.vue')
    },

    {
      path: '/Pro_move_details/:orderid',
      name: 'Pro_move_details',
      meta: {
        title: '出库产品详情'
      },
      component: () => import('@/views/pro_move_details.vue')
    },
   
    {
      path: '/Pro_seema/:PNum/:TotalNum/:detailid',
      name: 'Pro_seema',
      meta: {
        title: '查看码单'
      },
      component: () => import('@/views/pro_seema.vue')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js